import React from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useStore } from "../../../../stores/store";
import { yupResolver } from "@hookform/resolvers/yup";
import { useTranslation } from "react-i18next";
import { useSnackbar } from "notistack";
import useAxiosPrivate from "../../../../hooks/useAxiosPrivate";
import { useSubmitData } from "../../../../hooks/useSubmitData";
import * as yup from "yup";
import { useSetMenu } from "../../../../hooks/useSetMenu";
import FormLayout from '../../../Generic/FormLayout';
import FormInput from '../../../Generic/FormInput';
import FormCheckbox from '../../../Generic/FormCheckbox';

const Add = () => {
  const { mainStore } = useStore();
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const axiosPrivate = useAxiosPrivate();
  useSetMenu(mainStore.MCDMMethodsAdminMenuType, mainStore.MCDMMethodsAdminMenuNo);

  const onError = (errors, e) =>
    enqueueSnackbar(t("onErrorSubmit"), { variant: "error" });

  const schema = yup.object({
    acronym: yup.string().required(t('requiredField')).max(20, t('maxLength', { max: 20 })),
    methodOrder: yup.number().required(t('requiredField')).min(1, t('minValue', { min: 1 })),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      methodOrder: 1,
      isVisible: true,
    }
  });

  const sendData = useSubmitData(axiosPrivate, "/MCDMMethods", "/Admin/MCDMMethods");
  const onSubmit = data => sendData(data);
  const onCancel = () => navigate(-1);

  return (
    <FormLayout title={t("mcdmMethodCreateTitle") || "Add MCDM Method"} onSubmit={handleSubmit(onSubmit, onError)} onCancel={onCancel}>
      <FormInput label="order" name="methodOrder" type="number" register={register} errors={errors} colSize={2} />
      <FormInput label="acronym" name="acronym" register={register} errors={errors} colSize={4} />
      <FormInput label="fullNameEN" name="fullNameEN" register={register} errors={errors} colSize={6} />
      <FormInput label="fullNameBG" name="fullNameBG" register={register} errors={errors} colSize={6} />
      <FormInput label="fullNameSQ" name="fullNameSQ" register={register} errors={errors} colSize={6} />
      <FormInput label="descriptionEN" name="descriptionEN" register={register} errors={errors} colSize={12} isTextArea={true} />
      <FormInput label="descriptionBG" name="descriptionBG" register={register} errors={errors} colSize={12} isTextArea={true} />
      <FormInput label="descriptionSQ" name="descriptionSQ" register={register} errors={errors} colSize={12} isTextArea={true} />
      <FormCheckbox label="isVisible" register={register} name="isVisible" colSize={4} />
    </FormLayout>
  );
};

export default Add;
